var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("experts.top_experts_title")))]),_c('BiExpertsTable',{attrs:{"items":_vm.items},on:{"getTask":_vm.showExpertsByTask}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }